import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

export const BASE_URL = `${Config.api.tenantSettings.url}api/v1/`;

class TenantSettingsService {
  getCompetitors(sorting_field, sorting_order) {
    return ApiService.get(
      `${BASE_URL}tenants/competitors?detailed=true&sorting_field=${sorting_field}&sorting_order=${sorting_order}`,
    ).then((response) => response.data);
  }
  getCompetitor(id) {
    return ApiService.get(`${BASE_URL}tenants/competitors/${id}`).then((response) => response.data);
  }
  getTenantNormalizedNames() {
    return ApiService.get(`${BASE_URL}tenants/normalized-names`).then((response) => response.data);
  }
  addTenantNormalizedNameMany(normalizedNames) {
    return ApiService.post(`${BASE_URL}tenants/normalized-names/batch`, normalizedNames).then(
      (response) => response.data,
    );
  }
  editTenantNormalizedName(id, normalizedName) {
    return ApiService.put(`${BASE_URL}tenants/normalized-names/${id}`, { normalizedName }).then(
      (response) => response.data,
    );
  }
  deleteTenantNormalizedName(id) {
    return ApiService.delete(`${BASE_URL}tenants/normalized-names/${id}`).then((response) => response.data);
  }
  addCompetitor(competitor) {
    return ApiService.post(`${BASE_URL}tenants/competitors`, competitor).then((response) => response.data);
  }
  editCompetitor(id, competitor) {
    return ApiService.put(`${BASE_URL}tenants/competitors/${id}`, competitor).then((response) => response.data);
  }
  deleteCompetitor(id) {
    return ApiService.delete(`${BASE_URL}tenants/competitors/${id}`).then((response) => response.data);
  }

  getTenantDescriptions() {
    return ApiService.get(`${BASE_URL}tenants/descriptions`).then((response) => response.data);
  }

  updateTenantDescription(payload) {
    return ApiService.put(`${BASE_URL}tenants/descriptions`, payload).then((response) => response.data);
  }

  generateTenantDescriptionPreview(url) {
    return ApiService.post(`${BASE_URL}tenants/descriptions/preview`, { url }).then((response) => response.data);
  }

  approveTenantDescriptionPreview(body) {
    return ApiService.post(`${BASE_URL}tenants/descriptions/approve`, body).then((response) => response.data);
  }

  getTenantWebsite() {
    return ApiService.get(`${BASE_URL}tenants/descriptions/websites`).then((response) => response.data);
  }

  upsertTenantWebsite(url) {
    return ApiService.put(`${BASE_URL}tenants/descriptions/websites`, { url }).then((response) => response.data);
  }
}

export const tenantSettingsService = new TenantSettingsService();
